import { render } from "./Header.vue?vue&type=template&id=f86506e2"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=f86506e2&lang=css"
script.render = render

export default script